export default "__VITE_ASSET__DjL0doHs__"